<template>
  <div class="dg-footer-bg w-[100%] h-[415]">
    <div class="w-[1200] mx-[auto] pt-[76] t-[#fff]">
      <div class="flex">
        <div>
          <p class="flex items-center">
            <i class="iconfont-logo logoIcon-yancheng t-[25]"></i>
            <span class="t-[18] font-600 pl-[5]">盐城市数字化一体化电子保函综合服务平台</span>
          </p>
          <p class="mt-[30] w-[423] t-[14] font-600 leading-[26]">
            提供以电子债权凭证为模式的应收账款融资、预付款融资、存货融资等多重供应链融资服务，全流程线上化操作
          </p>
        </div>
        <div class="flex flex-1">
          <div class="ml-[170]">
            <p class="font-600 pb-[22]">联系我们</p>
            <p class=" mb-[18] t-[26] font-600">400-816-1767</p>
            <p class="mb-[8] t-[rgb(255,255,255,0.8)]">邮箱：ght@nongdaxia.com.cn</p>
            <p class="t-[rgb(255,255,255,0.8)]">地址：盐城市经济技术开发区新都东路82号金控大厦</p>
          </div>
          <div class="ml-[40]">
            <p class="font-600 pb-[24]">快速导航</p>

            <p class="mb-[8]"><a href="https://www.ycbaohan.com/" target="_blank" class="t-[rgb(255,255,255,0.8)] no-underline">电子保函</a>
            </p>
            <p @click="push({ path: '/news' })" class="cursor-pointer mb-[8] t-[rgb(255,255,255,0.8)]">政策资讯</p>
            <p @click="push({ path: '/contract' })" class="cursor-pointer"><span class="t-[rgb(255,255,255,0.8)] no-underline">关于我们</span></p>
          </div>
          <div class="ml-[auto]">
            <p class="font-600 pb-[23]">了解更多</p>
            <p>
              <img src="../assets/img/img1.png" class="w-[72]" alt="">
            </p>
            <p>微信公众号</p>
          </div>
        </div>

      </div>
      <div class="border-y-[1] border-[rgba(255,255,255,0.30)] border-solid py-[12] text-center mt-[54] t-[rgb(255,255,255,0.8)]">
        <p class="mb-[8]">指导单位：盐城市发展和改革委员会、盐城市财政局、盐城市国资委、盐城市数据局、盐城市市场监督管理局、人民银行盐城市分行、盐城市金融监管分局</p>
        <p><span>主办单位：江苏黄海金融控股集团有限公司</span> <span>运营单位：盐城函通科技有限公司</span> </p>
      </div>
      <div class="t-[rgba(255,255,255,0.60)] text-center mt-[14] t-[12]">
        <p>声明：本平台仅提供技术支持，所有贷款、融资产品均由本平台合作金融机构提供</p>
        <p><span>版权所有：盐城函通科技有限公司</span> <span>苏ICP备2024119490号</span> </p>
      </div>
    </div>
  </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
export default {
  mixins: [mixin],
  name: "dg-footer",
  data() {
    return {}
  },
  methods: {},
  mounted() { },
  created() { },
}
</script>
<style scoped lang="less">
.dg-footer-bg {
  background-image: url('../assets/img/banner2.png');
  background-size: 100% 415px;
  background-position: center center;
  background-repeat: no-repeat;
}
</style>
 <style>.w-\[100\%\] {
    width: 100%
}
.h-\[415\] {
    height: 415px
}
.w-\[1200\] {
    width: 1200px
}
.mx-\[auto\] {
    margin-left: auto;
    margin-right: auto
}
.pt-\[76\] {
    padding-top: 76px
}
.t-\[\#fff\] {
    color: #fff
}
.t-\[25\] {
    font-size: 25px
}
.t-\[18\] {
    font-size: 18px
}
.pl-\[5\] {
    padding-left: 5px
}
.mt-\[30\] {
    margin-top: 30px
}
.w-\[423\] {
    width: 423px
}
.t-\[14\] {
    font-size: 14px
}
.leading-\[26\] {
    line-height: 26px
}
.ml-\[170\] {
    margin-left: 170px
}
.pb-\[22\] {
    padding-bottom: 22px
}
.mb-\[18\] {
    margin-bottom: 18px
}
.t-\[26\] {
    font-size: 26px
}
.mb-\[8\] {
    margin-bottom: 8px
}
.t-\[rgb\(255\,255\,255\,0\.8\)\] {
    color: rgb(255,255,255,0.8)
}
.ml-\[40\] {
    margin-left: 40px
}
.pb-\[24\] {
    padding-bottom: 24px
}
.ml-\[auto\] {
    margin-left: auto
}
.pb-\[23\] {
    padding-bottom: 23px
}
.w-\[72\] {
    width: 72px
}
.border-y-\[1\] {
    border-top-width: 1px;
    border-bottom-width: 1px
}
.border-\[rgba\(255\,255\,255\,0\.30\)\] {
    border-color: rgba(255,255,255,0.30)
}
.py-\[12\] {
    padding-top: 12px;
    padding-bottom: 12px
}
.mt-\[54\] {
    margin-top: 54px
}
.t-\[rgba\(255\,255\,255\,0\.60\)\] {
    color: rgba(255,255,255,0.60)
}
.mt-\[14\] {
    margin-top: 14px
}
.t-\[12\] {
    font-size: 12px
}
.flex {
    display: flex
}
.items-center {
    align-items: center
}
.font-600 {
    font-weight: 600
}
.flex-1 {
    flex: 1 1 0%
}
.no-underline {
    text-decoration: none
}
.cursor-pointer {
    cursor: pointer
}
.border-solid {
    border-style: solid
}
.text-center {
    text-align: center
}</style>